module.exports = __webpack_public_path__ + "img/point2.1f241023.png";